import { BaseDataService } from './Base/BaseDataService';
import { ControlListApiDataResponse } from '../Models/Control/Control';
import { XHRRequestCanceler } from '../../Libs/xhr/XHRRequestCanceler';
import { ControlListTodayViewType } from '../ViewModels/Controles/ControleListToday/ControleListTodayViewState';

const ControlsEndpoints = {
    CONTROL_LIST: '/api/v1/back/checks',
    CONTROL_AFFAIRES_LIST: () => `/api/v1/back/affaires/checks`,
    CONTROL_CURRENT_LIST: (day_date: string) => `/api/v1/back/affaires/checks/currentday/${day_date}`,
};

export interface IControlsDataService {
    getControlsList: (
        params: {
            check_template_id?: string;
            from_day_date?: string;
            to_day_date?: string;
            compagnon_id?: string;
            affaire_id?: string;
        },
        cts: XHRRequestCanceler
    ) => Promise<ControlListApiDataResponse>;

    getControlTodayList: (
        params: {
            compagnonId?: string;
            day_date?: string;
            from_day_date?: string;
            to_day_date?: string;
        },
        cts: XHRRequestCanceler,
        state: ControlListTodayViewType
    ) => Promise<ControlListApiDataResponse>;
}

class ControlsDataService extends BaseDataService implements IControlsDataService {
    getControlsList = (
        params: {
            check_template_id?: string;
            from_day_date?: string;
            to_day_date?: string;
            compagnon_id?: string;
            affaire_id?: string;
        },
        cts: XHRRequestCanceler
    ) => {
        return this.get<ControlListApiDataResponse>(ControlsEndpoints.CONTROL_LIST, cts, {
            params,
        });
    };

    getControlTodayList = (
        params: {
            compagnonId?: string;
            day_date?: string;
            from_day_date?: string;
            to_day_date?: string;
        },
        cts: XHRRequestCanceler,
        state: ControlListTodayViewType
    ) => {
        const url =
            state === ControlListTodayViewType.Today
                ? ControlsEndpoints.CONTROL_AFFAIRES_LIST()
                : params.day_date ? ControlsEndpoints.CONTROL_CURRENT_LIST(params.day_date) : '';
        const paramsToSend = state === ControlListTodayViewType.Today ? {
            compagnon_id: params.compagnonId,
            from_day_date: params.from_day_date,
            to_day_date: params.to_day_date,
        } : {
            compagnon_id: params.compagnonId,
        }
        return this.get<ControlListApiDataResponse>(url, cts, {
            params: paramsToSend,
        });
    };
}

const ControlsDataServiceName = 'ControlsDataService';

export { ControlsDataService, ControlsDataServiceName };
